import { sortBy } from "lodash";
import moment from "moment";

import { KPISummaryTableCell } from "@apps/kpis/components/summary-table-row";
import { classNames } from "@helpers/css";

export const KPIGroupViewMeasurementCell = ({
  kpi,
  limit,
  onAddValue,
}: {
  kpi: any;
  limit: number;
  onAddValue: () => void;
}) => {
  const measurements = sortBy(
    kpi.summarizedMeasurements.edges,
    ({ node }) => -moment(node.date).unix(),
  )
    .slice(0, limit)
    .reverse();
  return measurements.map(({ node }, i) => (
    <td
      className={classNames("border! p-0! border-b-0! border-r-0!")}
      key={node.date}
    >
      <KPISummaryTableCell
        key={i}
        kpi={kpi}
        isLastCell={i === measurements.length - 1}
        measurement={node}
        previousMeasurement={measurements[i - 1]?.node}
        className={classNames(
          "px-2 h-14 py-2 text-gray-500 text-center text-sm",
        )}
        onAddValue={onAddValue}
      />
    </td>
  ));
};
